import GlobalFetchData from './GlobalFetchData';

export default GlobalFetchData;
